import type { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface NameInputProps {
  register: UseFormRegisterReturn;
  error?: string;
  disabled?: boolean;
  className?: string;
}

export function NameInput({
  register,
  error,
  disabled = false,
  className,
}: NameInputProps) {
  const { t } = useTranslation();

  return (
    <div className={`space-y-2 ${className || ''}`}>
      <div className="flex items-center justify-between">
        <Label htmlFor="user-name" className="text-sm font-medium">
          {t('form.userName.label')}
        </Label>
      </div>
      <Input
        {...register}
        id="user-name"
        type="text"
        placeholder={t('form.userName.placeholder')}
        disabled={disabled}
        className={error ? 'border-destructive focus-visible:ring-destructive' : ''}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? 'user-name-error' : undefined}
      />
      {error && (
        <p id="user-name-error" className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
